// module imports
import AOS from "aos";

//
// Main
//

jQuery(function ($) {
  // AOS initialisieren
  AOS.init({
    duration: 800,
    once: true,
    offset: 50,
    easing: "ease-out",
  });

  // Anker ohne URL-Änderung (gleiche Seite)
  $(document).on("click", 'a[href^="#"]', function (e) {
    const targetId = $(this).attr("href");
    if (!targetId || targetId === "#") return;

    const $target = $(targetId);
    if ($target.length) {
      e.preventDefault();
      const offset = $(".site-header").outerHeight() || 160;
      const targetPos = $target.offset().top - offset;
      window.scrollTo({ behavior: "smooth", top: targetPos });
    }
  });

  $(".heroslider").flexslider({
    animation: "fade",
    controlNav: true,
    directionNav: false,
    slideshow: true,
    slideshowSpeed: 7000,
    animationSpeed: 1200,
    start: function (slider) {
      // Text/Overlay mit Verzögerung einblenden
      setTimeout(function () {
        $(slider.slides[slider.currentSlide]).addClass("is-anim");
      }, 800);
    },
    before: function (slider) {
      // Alten Slide: Text/Overlay sofort ausblenden
      slider.slides.removeClass("is-anim");
    },
    after: function (slider) {
      // Neuer Slide: Text/Overlay verzögert einblenden
      setTimeout(function () {
        $(slider.slides[slider.currentSlide]).addClass("is-anim");
      }, 800);
    },
  });

  // Flexslider
  $(".flexslider").flexslider({
    animation: "slide",
    controlNav: true,
    directionNav: false,
    slideshow: true,
    slideshowSpeed: 5000,
    animationSpeed: 1200,
    start: function (slider) {
      var maxH = 0;
      slider.slides.find("img").each(function () {
        if (this.complete && this.naturalHeight) {
          var h = (this.naturalHeight / this.naturalWidth) * $(this).width();
          if (h > maxH) maxH = h;
        }
      });
      if (maxH) {
        // Höhe als CSS-Variable auf den Slider setzen
        slider.css("--slide-height", maxH + "px");
      }
    },
  });

  // Hamburger Menu
  const $toggle = $(".js-menu-toggle");
  const $menu = $("#fullscreen-menu");

  function openMenu() {
    $menu.addClass("is-open");
    $toggle.addClass("is-open").attr("aria-expanded", "true");
    $("body").addClass("no-scroll menu-opened");
    $(".site-header").addClass("no-bg");
  }

  function closeMenu() {
    $menu.removeClass("is-open");
    $toggle.removeClass("is-open").attr("aria-expanded", "false");
    $(".site-header").removeClass("no-bg");
    $("body").removeClass("no-scroll menu-opened");
  }

  $toggle.on("click", function () {
    if ($menu.hasClass("is-open")) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && $menu.hasClass("is-open")) {
      closeMenu();
    }
  });

  // Hamburger Farbe anpassen wenn hero-abstand der erste Block ist
  if ($("main").children().first().hasClass("hero-abstand") || $("main").children().first().find(".hero-abstand").length > 0) {
    $(".hamburger span, .hamburger span::before, .hamburger span::after").addClass("hamburger-dark");
  }

  // Header kompakt beim Scrollen
  const $headerBar = $(".site-header");

  $(window).on("scroll", function () {
    const current = $(this).scrollTop();
    if (current > 40) {
      $headerBar.addClass("header-compact");
    } else {
      $headerBar.removeClass("header-compact");
    }
  });

  // Akkordeon mit jQuery
  $(document).on("click", ".akkordeon-header", function (e) {
    e.preventDefault();
    console.log("Akkordeon Header geklickt");

    const $item = $(this).closest(".akkordeon-item");
    const $content = $item.find(".akkordeon-content");
    const isOpen = $item.hasClass("is-open");

    // Alle anderen Akkordeons schließen
    $(".akkordeon-item")
      .not($item)
      .each(function () {
        $(this).removeClass("is-open");
        $(this).find(".akkordeon-content").css("max-height", "0");
        $(this).find(".akkordeon-header").attr("aria-expanded", "false");
      });

    // Toggle aktuelles Akkordeon
    if (isOpen) {
      $item.removeClass("is-open");
      $content.css("max-height", "0");
      $(this).attr("aria-expanded", "false");
    } else {
      $item.addClass("is-open");
      $content.css("max-height", $content[0].scrollHeight + "px");
      $(this).attr("aria-expanded", "true");
    }
  });
});

// Floating Labels
document.querySelectorAll(".kontaktformular .form-field").forEach((field) => {
  const input = field.querySelector("input, textarea");
  if (!input) return;

  // Beim Laden prüfen ob bereits ausgefüllt
  if (input.value.trim() !== "") {
    field.classList.add("is-filled");
  }

  input.addEventListener("focus", () => {
    field.classList.add("is-active");
  });

  input.addEventListener("blur", () => {
    field.classList.remove("is-active");
    if (input.value.trim() !== "") {
      field.classList.add("is-filled");
    } else {
      field.classList.remove("is-filled");
    }
  });
});

// GET-Parameter "kurs" in inputFieldPrefilled einfügen
const urlParams = new URLSearchParams(window.location.search);
const kurs = urlParams.get("kurs");

if (kurs) {
  const prefilled = document.querySelector(".inputFieldPrefilled select");
  if (prefilled) {
    const kursLower = kurs.toLowerCase();
    const matchingOption = Array.from(prefilled.options).find((option) => option.value.toLowerCase().includes(kursLower) || option.text.toLowerCase().includes(kursLower));
    if (matchingOption) {
      prefilled.value = matchingOption.value;
      prefilled.closest(".form-field")?.classList.add("is-filled");
    }
  }
}

// Google Maps
function initializeMap() {
  if (!document.getElementById("mapWrapper")) return;

  const locations = [["IK Atelier", "Meisenrain 10, 8044 Gockhausen", 47.382835, 8.599184]];

  const map = new google.maps.Map(document.getElementById("mapWrapper"), {
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    scrollwheel: false,
    zoomControl: true,
    streetViewControl: true,
    scaleControl: false,
    zoom: 15,
    styles: [
      { featureType: "water", stylers: [{ color: "#f7f7f7" }] },
      { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#FCFFF5" }] },
      { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#808080" }, { lightness: 54 }] },
      { featureType: "landscape.man_made", elementType: "geometry.fill", stylers: [{ color: "#dde1d4" }] },
      { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#73AB7D" }] },
      { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#767676" }] },
      { featureType: "road", elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
      { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ color: "#7e7341" }] },
      { featureType: "landscape.natural", elementType: "geometry.fill", stylers: [{ visibility: "on" }, { color: "#dee6e6" }] },
      { featureType: "poi.park", stylers: [{ visibility: "on" }] },
      { featureType: "poi.sports_complex", stylers: [{ visibility: "on" }] },
      { featureType: "poi.medical", stylers: [{ visibility: "on" }] },
      { featureType: "poi.business", stylers: [{ visibility: "simplified" }] },
    ],
  });

  const infowindow = new google.maps.InfoWindow({ content: "loading..." });

  locations.forEach((location) => {
    const latlng = new google.maps.LatLng(location[2], location[3]);
    const content = `<div class="infoWindow">${location[0]}<br>${location[1]}</div>`;

    const marker = new google.maps.Marker({
      position: latlng,
      title: "IK Atelier",
      map: map,
    });

    marker.addListener("click", () => {
      infowindow.setContent(content);
      infowindow.open(map, marker);
    });

    map.setCenter(latlng);
  });
}

// Google Maps API laden
if (document.getElementById("mapWrapper")) {
  const script = document.createElement("script");
  script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyD2CZuSOwm9lufpm2p4pd5iE-TeptnyNv4&callback=initializeMap";
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
  window.initializeMap = initializeMap;
}
